import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    syncChannel = new Subject()
    PresensiKetidakhadiranExportChannel = new Subject()
    repository = new IndexRepository()

    constructor() {
        this.syncChannel.next({status: apiResponse.INITIAL})
        this.PresensiKetidakhadiranExportChannel.next({status: apiResponse.INITIAL})
    }

    fetchSync = async (query) => {
        try {
            this.syncChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchSync(query).then((result) => {
                this.syncChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.syncChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {   }
    }

    fetchPresensiKetidakhadiranExport = async (query) => {
        this.PresensiKetidakhadiranExportChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPresensiKetidakhadiranExport(query).then((result) => {
            this.PresensiKetidakhadiranExportChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.PresensiKetidakhadiranExportChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default IndexBloc